<template lang="pug">
  ValidationObserver(
    ref="form"
    slim
    tag="div"
  )
    h2(
      v-if="title"
      class="fw-700 mb-6"
      :class="[xsDevice ? 'title-24px' : 'title-32px']"
    ) {{ $t(title) }}
    t-orm-fields(
      v-bind.sync="editedItem"
      :items="fields"
    )
    div(class="two-buttons-wrapper")
      v-btn(
        v-if="cancelBtn"
        class="secondary-button color-error"
        @click="cancel"
        :loading="loading"
      ) {{ $t(cancelBtnText) }}
      v-btn(
        class="main-button"
        @click="submit"
        :loading="loading"
      ) {{ $t(buttonText) }}
</template>

<script>
import TOrmFields from '~/components/templates/orm/t-orm-fields'
import responsive from '~/mixins/pages/responsive'

export default {
  components: {
    TOrmFields
  },
  mixins: [responsive],
  props: {
    context: {
      type: String,
      default: 'create',
      validator: value => {
        return ['create', 'update'].includes(value)
      }
    },
    title: {
      type: String,
      default: null
    },
    fields: {
      type: Array,
      required: true,
      default: () => []
    },
    onSubmit: {
      type: Function,
      default: () => {}
    },
    onCancel: {
      type: Function,
      default: () => {}
    },
    buttonText: {
      type: String,
      default: 'Download'
    },
    cancelBtnText: {
      type: String,
      default: 'Cancel'
    },
    successMessage: {
      type: String,
      default: ''
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    cancelBtn: {
      type: Boolean,
      default: false
    },
    item: {
      type: null,
      default: null
    }
  },
  data: () => ({
    editedItem: {},
    loading: false
  }),
  created() {
    this._.forEach(this.fields, field => {
      if (field.model) {
        this.editedItem[field.model] =
          (field.default && this._.isFunction(field.default)
            ? field.default(this.context, this.item)
            : field.default) || null
      }
    })
  },
  methods: {
    async cancel() {
      if (this._.isFunction(this.onCancel)) {
        await this.onCancel(this.editedItem, this)
      }
      this._.forEach(this.editedItem, field => this.$set(this.editedItem, field, null))
    },
    async submit() {
      const valid = await this.$refs.form.validate()

      if (valid && typeof this.onSubmit === 'function') {
        try {
          this.loading = true
          await this.onSubmit(this.editedItem, this)

          if (this.successMessage) {
            this.$notification.success(this.$t(this.successMessage))
          }
        } catch (e) {
          this.$handlers.error(e, this.$refs.form)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
//
</style>
